export default function SvgTranslate() {
 return (
     <>
      {/*<svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        cursor="pointer"
        fill="#000"
        viewBox="0 0 256 256"
        >
        <path d="M235.572 214.21l-56-112a4 4 0 00-7.156 0l-22.854 45.709a92.045 92.045 0 01-55.572-20.575A99.707 99.707 0 00123.907 60h28.087a4 4 0 000-8h-60V32a4 4 0 00-8 0v20h-60a4 4 0 000 8h91.908a91.742 91.742 0 01-27.92 62.034 91.674 91.674 0 01-22.748-35.367 4 4 0 00-7.542 2.668 99.63 99.63 0 0024.305 38.02A91.565 91.565 0 0123.994 148a4 4 0 000 8 99.545 99.545 0 0064-23.225 100.104 100.104 0 0057.654 22.972l-29.231 58.464a4 4 0 107.155 3.578L138.466 188h75.056l14.895 29.79a4 4 0 107.155-3.58zM142.466 180l33.528-67.056L209.522 180z"></path>
      </svg>*/}

      <svg
       xmlns="http://www.w3.org/2000/svg"
       width="20px"
       cursor="pointer"
       fill="#000"
       viewBox="0 0 256 256"
      >
      <path d="M239.132 212.422l-56-112a8 8 0 00-14.31 0l-21.698 43.395a88.012 88.012 0 01-47.153-16.9A103.64 103.64 0 00127.671 64h24.306a8 8 0 000-16h-56V32a8 8 0 00-16 0v16h-56a8 8 0 000 16h87.632a87.713 87.713 0 01-23.64 52.341 87.629 87.629 0 01-18.982-31.009 8 8 0 10-15.083 5.338 103.56 103.56 0 0022.082 36.27A87.527 87.527 0 0123.976 144a8 8 0 000 16 103.485 103.485 0 0064.014-22.09 104.142 104.142 0 0051.441 21.292l-26.61 53.22a8 8 0 0014.31 7.156L140.922 192h70.111l13.79 27.578a8 8 0 0014.31-7.156zM148.92 176l27.056-54.111L203.032 176z"></path>
    </svg>
    </>
   )
 }